<p>Break down by</p>
@for (target of drilldownItems(); track target.dimensionName) {
  <button appTrackEvent="DrillDownClicked" [eventProperties]="{dimensionName: target.dimensionName}" (click)="handleDrilldown(target.nextLevel)" [disabled]="!target.nextLevel" data-test="drill-down-button">
    <span>
    {{ target.dimensionName }}
    </span>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <use [attr.xlink:href]="SvgSpriteIcon.ArrowForward"></use>
    </svg>
  </button>
}
